import type {LegacyIconName, NewIconName} from './icon';

// Mapping from old icon names to new icon keys, variants, and sizes
export const legacyIconMap: Record<LegacyIconName, NewIconName> = {
  analytics: 'bar-chart-01/outlined/20',
  archive: 'archive/outlined/20',
  article: 'file-02/outlined/20',
  assign: 'user-left-01/outlined/20',
  attachment: 'paperclip/outlined/20',
  attachmentSmall: 'paperclip/outlined/16',
  auditLogFilledSmall: 'audit-log/filled/16',
  auditLogSmall: 'audit-log/outlined/16',
  auditTrail: 'clock-rewind/outlined/20',
  autoContactFilledSmall: 'contact-auto/filled/16',
  autoContactFilledTiny: 'contact-auto/filled/12',
  autoContactSmall: 'contact-auto/outlined/16',
  backspaceOutlined: 'delete/outlined/20',
  bell: 'bell-01/filled/20',
  bell02Small: 'bell-01/outlined/16',
  bellCrossedSmall: 'bell-off-01/filled/16',
  bellSmall: 'bell-01/filled/16',
  bellTiny: 'bell-01/filled/12',
  blocks: 'cube-01/filled/20',
  briefcaseFilled: 'briefcase-01/filled/20',
  briefcaseFilledSmall: 'briefcase-01/filled/16',
  briefcaseOutline: 'briefcase-01/outlined/20',
  briefcaseOutlineSmall: 'briefcase-01/outlined/16',
  buildingFilled: 'building-05/outlined/20',
  buildingFilledCompany: 'building-05/filled/20',
  buildingFilledSmall: 'building-05/filled/16',
  businessHoursFilled: 'business-hours/filled/20',
  busyFilledTiny: 'user-right-off/filled/12',
  calendar: 'calendar/filled/20',
  calendarFilled: 'calendar/filled/20',
  calendarFilledSmall: 'calendar/filled/16',
  calendarInvite: 'calendar-plus-02/outlined/20',
  calendarSelected: 'calendar-check-02/filled/20',
  calendarSmall: 'calendar/outlined/16',
  calendars: 'calendar/outlined/20',
  callAnsweredActivity: 'phone-incoming-01/outlined/12',
  callEndedActivity: 'phone-hang-up/outlined/12',
  callFilled: 'phone/filled/20',
  callInboundFilledSmall: 'phone-incoming-01/filled/16',
  callMissedActivity: 'phone-x/outlined/12',
  callMissedSmall: 'phone-x/filled/16',
  callOnHoldActivity: 'phone-pause/outlined/12',
  callOutboundFilledSmall: 'phone-outgoing-01/filled/16',
  callOutlined: 'phone/outlined/20',
  callOutlinedSmall: 'phone/outlined/16',
  callQueuedActivity: 'clock/outlined/12',
  callResumedActivity: 'play/outlined/12',
  callTransferredActivity: 'arrow-block-right/outlined/12',
  caseStudySmall: 'file-search-01/filled/16',
  changeStatus: 'status-change/outlined/20',
  changeStatusFilled: 'status-change/filled/20',
  changeStatusFilledSmall: 'status-change/filled/16',
  changeStatusSmall: 'status-change/outlined/16',
  channelCallFilled: 'phone-call-01/filled/20',
  channelCallFilledSmall: 'phone-call-01/filled/16',
  channelCallOutlineSmall: 'phone-call-01/outlined/16',
  channelChat: 'chat/filled/20',
  channelChatOutlineSmall: 'chat/outlined/16',
  channelChatSmall: 'chat/filled/16',
  channelEmail: 'mail-01/outlined/20',
  channelEmailOutlineSmall: 'mail-01/outlined/16',
  channelEmailSmall: 'mail-01/outlined/16',
  channelGooglePlayOutlineSmall: 'google-play/outlined/16',
  channelGooglePlaySmall: 'google-play/filled/16',
  channels: 'grid-01/outlined/20',
  channelsFilled: 'grid-01/filled/20',
  channelsFilledSmall: 'grid-01/filled/16',
  channelsSmall: 'grid-01/outlined/16',
  chat: 'chat/outlined/20',
  chatDeflected: 'chat/outlined/20',
  chatEndedActivity: 'chat-ended-activity/outlined/12',
  chatFilled: 'chat/filled/20',
  chatbotFilledSmall: 'chat/filled/16',
  chatbotSmall: 'chat/outlined/16',
  checkCircleSmall: 'check-circle/outlined/16',
  checkSmallFilled: 'check-circle/filled/16',
  checkSmallOutline: 'check-circle/outlined/16',
  checkmark: 'check/outlined/20',
  checkmarkBoxSmall: 'check/outlined/16',
  checkmarkBoxTiny: 'check/outlined/12',
  checkmarkCircleLarge: 'check-circle/filled/20',
  checkmarkCircleOutlineSmall: 'check-circle/outlined/16',
  checkmarkCircleSmall: 'check-circle/filled/16',
  checkmarkSelectedSmall: 'check/outlined/16',
  checkmarkYesActivity: 'check-circle/filled/12',
  chevron: 'chevron-right/outlined/20',
  chevronCollapseSmall: 'caret-collapse/outlined/16',
  chevronCollapseTiny: 'caret-collapse/outlined/12',
  chevronDownSmall: 'chevron-down/outlined/16',
  chevronDownTiny: 'caret-expand/outlined/12',
  chevronExpandSettings: 'chevron-down/outlined/20',
  chevronExpandSmall: 'caret-expand/outlined/16',
  chevronExpandTiny: 'caret-expand/outlined/12',
  chevronLeftSmall: 'chevron-left/outlined/16',
  chevronRight: 'chevron-right/outlined/20',
  chevronRightSmall: 'chevron-right/outlined/16',
  chevronRightTiny: 'chevron-right/outlined/12',
  chevronUpSmall: 'chevron-up/outlined/16',
  circleLineSmall: 'minus-circle/outlined/16',
  clearSmall: 'x-circle/filled/16',
  clock: 'clock/filled/20',
  clock01Small: 'clock/outlined/16',
  clockRewindSmall: 'clock-rewind/outlined/16',
  clockTiny: 'clock/filled/12',
  close: 'x-close/outlined/20',
  closeSmall: 'x-close/outlined/16',
  closeTiny: 'x-close/outlined/12',
  closedActivity: 'minus-circle/outlined/12',
  code: 'code-01/outlined/20',
  codeFilledSmall: 'code-01/filled/16',
  codeSmall: 'code-01/outlined/16',
  collapse: 'minimize-01/outlined/20',
  collapseSmall: 'minimize-01/outlined/16',
  compose: 'edit-05/outlined/20',
  composeFilled: 'edit-01/filled/20',
  composeSmall: 'edit-05/outlined/16',
  contacts: 'user-square/filled/20',
  contactsCutout: 'user-square/filled/20',
  contactsFilled: 'user-square/filled/20',
  contactsFilledSmall: 'user-square/filled/16',
  contactsOutline: 'user-square/outlined/20',
  contactsSmall: 'user-square/outlined/16',
  content: 'align-left/outlined/20',
  contentSmall: 'align-left/outlined/16',
  copy: 'copy-file/outlined/20',
  copySmall: 'copy-06/outlined/16',
  copyTiny: 'copy-06/outlined/12',
  creditcardFilledSmall: 'credit-card-02/filled/16',
  creditcardSmall: 'credit-card-02/outlined/16',
  crossCircle: 'x-circle/filled/20',
  crossCircleSmall: 'x-circle/filled/16',
  crownSmall: 'crown/filled/16',
  csatFilled: 'check-verified-02/filled/20',
  csatFilledSmall: 'check-verified-02/filled/16',
  csatSmall: 'check-verified-02/outlined/16',
  csatSurvey: 'check-verified-02/filled/20',
  customFieldsActivity: 'field-custom/outlined/12',
  customFieldsFilled: 'field-custom/filled/20',
  customFieldsFilledSmall: 'field-custom/filled/16',
  customFieldsSmall: 'field-custom/outlined/16',
  customViews: 'views/outlined/20',
  customViewsFilled: 'views/filled/16',
  customViewsFilledSmall: 'views/filled/16',
  customViewsSmall: 'views/outlined/20',
  customerPortalFilled: 'customer-portal/filled/20',
  customerPortalFilledSmall: 'customer-portal/filled/16',
  customerPortalSmall: 'customer-portal/outlined/16',
  date: 'calendar/outlined/20',
  dateFilled: 'calendar/filled/20',
  dateFilledSmall: 'calendar/filled/16',
  dateSmall: 'calendar/outlined/16',
  delegationFilledSmall: 'user-right-01/filled/16',
  developers: 'code-01/outlined/20',
  diamondFilledSmall: 'diamond-01/filled/16',
  diamondFilledTiny: 'diamond-01/filled/12',
  diamondSmall: 'diamond-01/outlined/16',
  discussionFilledSmall: 'discussions/filled/16',
  discussionSmall: 'discussions/outlined/16',
  donotdisturbSmall: 'clock-snooze/filled/16',
  dotsGrid: 'dots-grid/outlined/20',
  download: 'download-02/outlined/20',
  downloadCircle: 'download-02/filled/20',
  downloadFilledSmall: 'download-02/filled/16',
  downloadLineSmall: 'download-02/outlined/16',
  downloadSmall: 'download-02/outlined/16',
  downloadTiny: 'download-02/outlined/12',
  draft: 'file-05/outlined/20',
  draftFilledSmall: 'file-05/filled/16',
  draftFilledTiny: 'file-05/filled/12',
  draftSmall: 'file-05/outlined/16',
  dropOffSmall: 'log-out-02/outlined/16',
  dropdownNew: 'plus/outlined/20',
  dropdownNewInbox: 'inbox-01/outlined/20',
  dropdownNewLink: 'link-03/outlined/20',
  dropdownNewTag: 'tag-01/outlined/20',
  dropdownUnassign: 'user-01/outlined/20',
  duplicateCopiesSmall: 'copy-file/filled/16',
  dynamicVariable: 'brackets-ellipses/outlined/20',
  dynamicVariableFilled: 'brackets-ellipses/filled/20',
  dynamicVariableFilledSmall: 'brackets-ellipses/filled/16',
  dynamicVariableSmall: 'brackets-ellipses/outlined/16',
  edit: 'edit-01/outlined/20',
  editSmall: 'edit-01/outlined/16',
  editTiny: 'edit-01/outlined/12',
  emoji: 'face-smile/outlined/20',
  emojiActivity: 'emoji-activity/outlined/16',
  emojiFlags: 'flag-01/outlined/20',
  emojiFood: 'emoji-food/outlined/20',
  emojiNature: 'emoji-nature/outlined/20',
  emojiObjects: 'lightbulb-04/outlined/20',
  emojiPeople: 'face-smile/outlined/20',
  emojiPlaceholderSmall: 'face-smile/outlined/16',
  emojiSmall: 'face-smile/outlined/16',
  emojiSymbols: 'emoji-symbols/outlined/20',
  emojiTravel: 'plane/outlined/20',
  endCallOutlined: 'phone-hang-up/outlined/20',
  exit: 'x-close/outlined/20',
  exitTiny: 'x-close/outlined/12',
  expand: 'expand-01/outlined/20',
  expandSmall: 'expand-01/outlined/16',
  export: 'export/outlined/20',
  exportSmall: 'export/outlined/16',
  externalLink: 'arrow-narrow-up-right/outlined/20',
  externalLinkCircle: 'arrow-narrow-up-right/filled/20',
  externalLinkSmall: 'arrow-narrow-up-right/outlined/16',
  externalLinkTiny: 'arrow-narrow-up-right/outlined/12',
  eye: 'eye/filled/20',
  eyeCrossedFilledSmall: 'eye-off/filled/16',
  eyeCrossedSmall: 'eye-off/outlined/16',
  eyeFilledSmall: 'eye/filled/16',
  eyeSmall: 'eye/outlined/16',
  facebookSmall: 'facebook/outlined/16',
  feather: 'feather/filled/20',
  featherFilledSmall: 'feather/filled/16',
  featherSmall: 'feather/outlined/16',
  file05Small: 'file-05/outlined/16',
  filters: 'filter-lines/outlined/20',
  filtersFilledSmall: 'filter-lines/filled/16',
  filtersSmall: 'filter-lines/outlined/16',
  fireSmall: 'hourglass-check/outlined/16',
  firstPageSmall: 'first-page/filled/16',
  flagSmall: 'flag-01/outlined/16',
  folder: 'folder/filled/20',
  folderLarge: 'folder/filled/20',
  folderOutline: 'folder/outlined/20',
  folderSmall: 'folder/filled/16',
  formatting: 'formatting/outlined/20',
  formattingBlockquote: 'formatting-quote/outlined/20',
  formattingBlockquoteSmall: 'formatting-quote/outlined/16',
  formattingBold: 'bold-01/outlined/20',
  formattingBoldSmall: 'bold-01/outlined/16',
  formattingColor: 'formatting-color/outlined/20',
  formattingColorSmall: 'formatting-color/outlined/16',
  formattingHighlight: 'formatting-highlight/outlined/20',
  formattingHighlightSmall: 'formatting-highlight/outlined/16',
  formattingImage: 'image-03/outlined/20',
  formattingItalic: 'italic-01/outlined/20',
  formattingItalicSmall: 'italic-01/outlined/16',
  formattingLink: 'link-03/outlined/20',
  formattingLinkSmall: 'link-03/outlined/16',
  formattingList: 'dotpoints-01/outlined/20',
  formattingListSmall: 'dotpoints-01/outlined/16',
  formattingNumberedListSmall: 'formatting-list/outlined/16',
  formattingRemove: 'type-strikethrough-01/outlined/20',
  formattingRemoveSmall: 'type-strikethrough-01/outlined/16',
  formattingStrikethrough: 'strikethrough-01/outlined/20',
  formattingStrikethroughSmall: 'strikethrough-01/outlined/16',
  formattingUnderline: 'underline-01/outlined/20',
  formattingUnderlineSmall: 'underline-01/outlined/16',
  forwardAsNewSmall: 'flip-forward-plus/outlined/16',
  forwardAudioFilled: 'forward-10s/filled/20',
  forwardFilled: 'corner-up-right/filled/20',
  forwardSmall: 'corner-up-right/outlined/16',
  frontLogoTiny: 'front-logo/filled/12',
  gear: 'settings-02/outlined/20',
  gearActivity: 'settings-02/outlined/12',
  gearFilled: 'settings-02/filled/20',
  gearFilledSmall: 'settings-02/filled/16',
  gearFilledTiny: 'settings-02/filled/12',
  gearSmall: 'settings-02/outlined/16',
  gif: 'gif/outlined/20',
  gifSmall: 'gif/outlined/16',
  giftSmall: 'gift-01/outlined/16',
  globeFilledSmall: 'globe-01/filled/16',
  globeSmall: 'globe-01/outlined/16',
  glossaryLineSmall: 'book-closed/outlined/16',
  goToConversation: 'go-to-conversation/outlined/20',
  grabHandleSmall: 'grab-handle/outlined/16',
  graduationCapFilledSmall: 'graduation-hat-01/filled/16',
  graduationCapOutlined: 'graduation-hat-01/outlined/20',
  grammarSmall: 'grammar/outlined/16',
  group: 'users/filled/20',
  groupActivity: 'layers-three-01/outlined/12',
  groupOutlineSmall: 'users/outlined/16',
  groupSmall: 'users/filled/16',
  guide: 'book-closed/outlined/20',
  help: 'help-circle/outlined/20',
  helpFilled: 'help-circle/filled/20',
  helpFilledSmall: 'help-circle/filled/16',
  helpFullsizeFilledSmall: 'help-circle/filled/16',
  helpIndicator: 'help-circle/outlined/20',
  helpSmall: 'help-circle/outlined/16',
  hideP1: 'layout-left/outlined/20',
  history: 'clock-rewind/outlined/20',
  hold: 'pause-circle/outlined/20',
  holdFilled: 'pause-circle/filled/20',
  homeFilled: 'home-05/filled/20',
  homeFilledSmall: 'home-05/filled/16',
  homeSmall: 'home-05/outlined/16',
  horizontalRule: 'divider/outlined/20',
  imageSmall: 'image-03/filled/16',
  imagesEmpty: 'image-03/outlined/20',
  inbox: 'inbox-01/outlined/20',
  inbox01Small: 'inbox-01/outlined/16',
  inboxActivity: 'inbox-01/outlined/12',
  inboxDeliverabilityFilledSmall: 'deliverability/filled/16',
  inboxDeliverabilitySmall: 'deliverability/outlined/16',
  inboxFilled: 'inbox-01/filled/20',
  inboxFilledSmall: 'inbox-01/filled/16',
  inboxInboundFilled: 'deliverability/filled/20',
  inboxListFilledSmall: 'inbox-list/filled/16',
  inboxListSmall: 'inbox-list/outlined/16',
  inboxSmall: 'inbox-01/outlined/16',
  inflowInbox: 'deliverability/filled/20',
  info: 'info-circle/outlined/20',
  infoFilled: 'info-circle/filled/20',
  infoFilledSmall: 'info-circle/filled/16',
  infoHistory: 'info-history/outlined/20',
  infoSmall: 'info-circle/outlined/16',
  integration: 'cube-01/outlined/20',
  integrationActivity: 'cube-01/outlined/12',
  integrationsFilled: 'cube-01/filled/20',
  integrationsFilledSmall: 'cube-01/filled/16',
  integrationsSmall: 'cube-01/outlined/16',
  intercomSmall: 'intercom/outlined/16',
  inviteActivity: 'user-plus-01/outlined/12',
  karlitoSmall: 'cloud-off/filled/16',
  keyboard: 'keyboard-02/filled/20',
  keypad: 'dots-grid/outlined/20',
  keypadFilled: 'dots-grid/filled/20',
  knowledgeBase: 'book-open-01/outlined/20',
  knowledgeBaseFilled: 'book-open-01/filled/20',
  knowledgeBaseFilledSmall: 'book-open-01/filled/16',
  knowledgeBaseOutlined: 'book-open-01/outlined/20',
  knowledgeBaseSmall: 'book-open-01/outlined/16',
  languageSmall: 'translate-01/outlined/16',
  lastPageSmall: 'last-page/outlined/16',
  lightThemeSmall: 'contrast-02/outlined/16',
  lightbulb: 'lightbulb-04/filled/20',
  lightbulbSmall: 'lightbulb-04/filled/16',
  lightbulbTiny: 'lightbulb-04/filled/12',
  lightning: 'lightning-01/outlined/20',
  lightningActivity: 'lightning-01/outlined/12',
  lightningFilled: 'lightning-01/filled/20',
  lightningFilledSmall: 'lightning-01/filled/16',
  lightningSmall: 'lightning-01/outlined/16',
  lightningTiny: 'lightning-01/filled/12',
  like: 'heart/outlined/20',
  likeFilled: 'heart/filled/20',
  link: 'link-03/outlined/20',
  linkSmall: 'link-03/outlined/16',
  linkTiny: 'link-03/outlined/12',
  linkToOriginalFilledSmall: 'link-to/filled/16',
  linkToOriginalSmall: 'link-to/outlined/16',
  linkedConversationsFilled: 'git-branch-01/filled/20',
  linkedConversationsFilledMedium: 'git-branch-01/filled/12',
  linkedConversationsFilledSmall: 'git-branch-01/filled/16',
  linkedConversationsFilledTiny: 'git-branch-01/filled/12',
  linkedConversationsSmall: 'git-branch-01/outlined/16',
  linkedConversationsTiny: 'git-branch-01/outlined/12',
  linkedFilledSmall: 'git-branch-01/filled/16',
  linkedSmall: 'git-branch-01/outlined/16',
  list: 'dotpoints-01/outlined/20',
  listFilled: 'file-02/filled/20',
  listFilledSmall: 'file-02/filled/16',
  listSmall: 'file-02/outlined/16',
  loaderRetry: 'refresh-cw-01/filled/20',
  loaderRetrySmall: 'refresh-cw-01/filled/16',
  locationSmall: 'marker-pin-01/outlined/16',
  lock: 'lock-01/filled/20',
  lockFilled: 'lock-01/filled/20',
  lockFilledNewTiny: 'lock-01/filled/12',
  lockFilledTiny: 'lock-01/filled/12',
  lockOutlineSmall: 'lock-01/outlined/16',
  lockSmall: 'lock-01/filled/16',
  meetingBufferSmall: 'divider/outlined/16',
  meetingBuildingSmall: 'building-05/outlined/16',
  meetingRoomSmall: 'door-open/outlined/16',
  mention: 'at-sign/outlined/20',
  mentionFilledSmall: 'at-sign/filled/16',
  mentionSmall: 'at-sign/outlined/16',
  menu: 'menu-01/outlined/20',
  merge: 'merge/outlined/20',
  mergeActivity: 'merge/outlined/12',
  mergeActivityFilled: 'merge/filled/12',
  mergeFilledSmall: 'merge/filled/16',
  mergeSmall: 'merge/outlined/16',
  message: 'mail-01/outlined/20',
  messageActivity: 'mail-01/outlined/12',
  messageSmall: 'mail-01/outlined/16',
  messageTemplate: 'message-template/outlined/20',
  messageTemplateFilled: 'message-template/filled/20',
  messageTemplateFilledSmall: 'message-template/filled/16',
  messageTemplateLarge: 'message-template/outlined/20',
  messageTemplateSmall: 'message-template/outlined/16',
  minusSmall: 'minus/outlined/16',
  moonFilledSmall: 'moon-02/filled/16',
  more: 'dots-horizontal/outlined/20',
  moreSmall: 'dots-horizontal/outlined/16',
  moreVertical: 'dots-vertical/outlined/20',
  moreVerticalSmall: 'dots-vertical/outlined/16',
  moveActivity: 'arrow-block-right/outlined/12',
  moveActivityFilled: 'arrow-block-right/filled/12',
  moveRightFilled: 'arrow-block-right/filled/20',
  moveRightFilledSmall: 'arrow-block-right/filled/16',
  moveRightSmall: 'arrow-block-right/outlined/16',
  mute: 'bell-off-01/outlined/20',
  muteFilled: 'bell-off-01/filled/20',
  muteSmall: 'bell-off-01/outlined/16',
  mutedStatusTiny: 'muted-status/filled/12',
  nestedArrowTiny: 'corner-down-right/outlined/12',
  new: 'plus/outlined/20',
  newAccountSmall: 'briefcase-01-plus/outlined/16',
  newContact: 'user-plus-01/outlined/20',
  newContactSmall: 'user-plus-01/outlined/16',
  newEvent: 'calendar-plus-02/outlined/20',
  newGroupSmall: 'users-plus/outlined/16',
  newMessageSmall: 'mail-notification/outlined/16',
  newSmall: 'plus/outlined/16',
  newTiny: 'plus/outlined/12',
  noTagSmall: 'tag-04/outlined/16',
  targetOffSmall: 'target-off/outlined/16',
  none: 'slash-circle-01/outlined/20',
  noneSmall: 'slash-circle-01/outlined/16',
  notAssignSmall: 'user-right-off/outlined/16',
  noteSmall: 'sticker-square/outlined/16',
  notesSmall: 'sticker-square/outlined/16',
  notificationSmall: 'alert-circle/filled/16',
  notificationStrokeSmall: 'alert-circle/outlined/16',
  numbers: 'numbers/outlined/20',
  numbersSmall: 'numbers/outlined/16',
  offlineFilledSmall: 'cloud-off/filled/16',
  ongoingRequestSmall: 'arrow-circle-broken-right/filled/16',
  oooTiny: 'minus-circle/filled/12',
  open01Small: 'open/filled/16',
  openPanel: 'layout-right/outlined/20',
  openSmall: 'mail-04/outlined/16',
  openSmallFilled: 'open/filled/16',
  optionalGuestFilledSmall: 'user-circle/filled/16',
  optionalGuestSmall: 'user-circle/outlined/16',
  outbox: 'outbox/filled/20',
  outboxFilledSmall: 'outbox/filled/16',
  outboxSmall: 'outbox/outlined/16',
  palmTree: 'user-x-01/filled/20',
  palmtreeFilledSmall: 'user-x-01/filled/16',
  palmtreeSmall: 'user-x-01/outlined/16',
  participantFilledSmall: 'user-01/filled/16',
  participantSmall: 'user-01/outlined/16',
  pauseFilled: 'pause/filled/20',
  personFilled: 'user-circle/filled/20',
  personSpeakingSmall: 'person-speaking/outlined/16',
  phishingSmall: 'alert-square/outlined/16',
  phone: 'phone-call-01/outlined/20',
  phoneSmall: 'phone-call-01/outlined/16',
  pinFilledSmall: 'pin-02/filled/16',
  pinFilledTiny: 'pin-02/filled/12',
  pinOutlineSmall: 'pin-02/outlined/16',
  pinSmall: 'pin-02/filled/16',
  planet: 'globe-04/filled/20',
  playFilled: 'play/filled/20',
  plusCircle: 'plus-circle/outlined/20',
  plusCircleFilledSmall: 'plus-circle/filled/16',
  plusCircleSmall: 'plus-circle/outlined/16',
  plusSmall: 'plus/outlined/16',
  plusTiny: 'plus/outlined/12',
  popin: 'popin/outlined/20',
  popout: 'arrow-narrow-up-right/outlined/20',
  popoutSmall: 'arrow-narrow-up-right/outlined/16',
  preferencesFilledSmall: 'sliders-04/filled/16',
  preferencesSmall: 'sliders-04/outlined/16',
  printSmall: 'printer/outlined/16',
  publicApiTiny: 'cube-outline/outlined/12',
  questionMark: 'help-circle/outlined/20',
  questionMarkTiny: 'help-circle/outlined/12',
  questionmarkMaybe: 'help-circle/outlined/20',
  questionmarkMaybeActivity: 'help-circle/filled/12',
  questionmarkMaybeSmall: 'help-circle/outlined/16',
  readSmall: 'mail-04/outlined/16',
  reminder: 'clock-snooze/outlined/20',
  removeActivity: 'user-x-01/outlined/12',
  removeIntegration: 'cube-01-off/outlined/20',
  removeIntegrationsSmall: 'cube-01-off/outlined/16',
  removeIntegrationActivity: 'cube-01-off/outlined/12',
  reopen: 'archive-off/filled/20',
  repeatCircle: 'refresh-cw-02/outlined/20',
  repeatCircleSmall: 'refresh-cw-02/outlined/16',
  repeatSmall: 'repeat-02/outlined/16',
  replaceAllSmall: 'replace-all/outlined/16',
  replayAudioFilled: 'rewind-10s/filled/20',
  repliedSmall: 'flip-backward/outlined/16',
  reply: 'corner-up-left/outlined/20',
  replyAll: 'corner-up-left-double/outlined/20',
  replyArrow: 'corner-up-left/filled/20',
  replyFilled: 'corner-up-left/filled/20',
  replyFilledSmall: 'corner-up-left/filled/16',
  replySmall: 'corner-up-left/outlined/16',
  replyAllSmall: 'corner-up-left-double/outlined/16',
  replyTiny: 'corner-up-left/outlined/12',
  requiredGuestSmall: 'user-circle/filled/16',
  resendAsNewSmall: 'send-04/outlined/16',
  resnooze: 'clock-rewind/outlined/20',
  restore: 'refresh-cw-01/outlined/20',
  retrySmall: 'refresh-cw-01/outlined/16',
  retweet: 'repeat-01/outlined/20',
  retweetSmall: 'repeat-01/outlined/16',
  retweeted: 'repeat-01/outlined/20',
  reviewedSmall: 'file-check-02/outlined/16',
  rocketFilled: 'rocket-02/filled/20',
  rocketFilledSmall: 'rocket-02/filled/16',
  ruleTest: 'rule-tester/outlined/20',
  save: 'save/outlined/20',
  savedFlow: 'dataflow-02/filled/20',
  savedFlowOutlineSmall: 'dataflow-02/outlined/16',
  savedFlowSmall: 'dataflow-02/filled/16',
  savedViewFilled: 'views/filled/20',
  savedViewFilledSmall: 'views/filled/16',
  savedViewSmall: 'views/outlined/16',
  schedule: 'calendar-check-02/outlined/20',
  scheduleFilled: 'calendar-check-02/filled/20',
  scheduleFilledSmall: 'calendar-check-02/filled/16',
  scheduleSmall: 'calendar-check-02/outlined/16',
  search: 'search-sm/outlined/20',
  searchSmall: 'search-sm/outlined/16',
  searchTiny: 'search-sm/outlined/12',
  section: 'distribute-spacing-vertical/outlined/20',
  sectionFilled: 'distribute-spacing-vertical/filled/20',
  send: 'send/outlined/20',
  send01Small: 'send/outlined/16',
  sendFilled: 'send/filled/20',
  sendFilledSmall: 'send/filled/16',
  sendSmall: 'send/outlined/16',
  sequences: 'layers-three-01/filled/20',
  settings: 'settings-02/outlined/20',
  sharedFilledSmall: 'users-01/filled/16',
  sharedFilledTiny: 'users-01/filled/12',
  sharedOutlineSmall: 'users-01/outlined/16',
  shiftScheduleFilledSmall: 'schedule/filled/16',
  shiftScheduleSmall: 'schedule/outlined/16',
  shiftsSmall: 'shift/outlined/16',
  sidePane: 'sidebar/outlined/20',
  sidebarFilledSmall: 'sidebar/filled/16',
  sla: 'hourglass-check/outlined/20',
  slaFilled: 'hourglass-check/filled/20',
  slaFilledSmall: 'hourglass-check/filled/16',
  slaSmall: 'hourglass-check/outlined/16',
  slackSmall: 'slack/filled/16',
  smartQAFilled: 'q-a-smart/filled/20',
  smartQAFilledSmall: 'q-a-smart/filled/16',
  smartQASmall: 'q-a-smart/outlined/16',
  snooze: 'alarm-clock/outlined/20',
  snoozeActivity: 'alarm-clock/outlined/12',
  snoozeActivityFilled: 'alarm-clock/filled/12',
  snoozeFilled: 'alarm-clock/filled/20',
  snoozeFilledSmall: 'alarm-clock/filled/16',
  snoozeSmall: 'alarm-clock/outlined/16',
  sortSmall: 'switch-vertical-01/outlined/16',
  spam: 'alert-hexagon/outlined/20',
  spamFilled: 'alert-hexagon/filled/20',
  spamFilledSmall: 'alert-hexagon/filled/16',
  spamSmall: 'alert-hexagon/outlined/16',
  sparklesAi: 'star-04/outlined/20',
  sparklesAiFilled: 'star-04/filled/20',
  sparklesAiFilledSmall: 'star-04/filled/16',
  sparklesAiFilledTiny: 'star-04/filled/12',
  sparklesAiSmall: 'star-04/outlined/16',
  splitActivity: 'split/outlined/12',
  splitActivityFilled: 'split/filled/12',
  splitFilledSmall: 'split/filled/16',
  splitSmall: 'split/outlined/16',
  squareFilled: 'square/filled/20',
  squareFilledSmall: 'square/filled/16',
  stageFilled: 'status-change/filled/20',
  stageFilledSmall: 'status-change/filled/16',
  stageSmall: 'status-change/outlined/16',
  star: 'star-01/outlined/20',
  starFilled: 'star-01/filled/20',
  starFilledSmall: 'star-01/filled/16',
  starSmall: 'star-01/outlined/16',
  starTiny: 'star-01/filled/12',
  statusAssignedSmallFilled: 'user-circle/filled/16',
  statusAssignedSmallOutline: 'user-circle/outlined/16',
  statusUnassignedSmallFilled: 'unassigned/filled/16',
  statusUnassignedSmallOutline: 'unassigned/outlined/16',
  subConvoFilledSmall: 'edit-05/filled/16',
  subConvoSmall: 'edit-05/outlined/16',
  subscribeFilledSmall: 'bell-01/filled/16',
  subscribeSmall: 'bell-01/outlined/16',
  subscribeTiny: 'bell-01/outlined/12',
  subscribed: 'bell-01/outlined/20',
  switchFilledSmall: 'switch-horizontal-01/filled/16',
  table: 'table/outlined/20',
  tableColumn: 'table-column/outlined/20',
  tableColumnSmall: 'table-column/outlined/16',
  tableGrid: 'table/outlined/20',
  tableGridFilled: 'table/filled/20',
  tableGridFilledSmall: 'table/filled/16',
  tableGridSmall: 'table/outlined/16',
  tag: 'tag-01/outlined/20',
  tagActivity: 'tag-01/outlined/12',
  tagActivityFilled: 'tag-01/filled/12',
  tagFilled: 'tag-01/filled/20',
  tagFilledSmall: 'tag-01/filled/16',
  tagIsNotFilledSmall: 'tag-04/filled/16',
  tagSmall: 'tag-01/outlined/16',
  tags: 'tag-03/outlined/20',
  tagsFilledSmall: 'tag-03/filled/16',
  tagsSmall: 'tag-03/outlined/16',
  task: 'task/outlined/20',
  taskLarge: 'task/outlined/20',
  taskFilled: 'task/filled/20',
  taskFilledSmall: 'task/filled/16',
  taskFilledTiny: 'task/filled/12',
  taskSmall: 'task/outlined/16',
  taskTiny: 'task/outlined/12',
  teammateFilled: 'user-01/filled/20',
  teammateRole: 'user-check-01/outlined/20',
  teammateRoleFilledSmall: 'user-check-01/filled/16',
  teammateRoleSmall: 'user-check-01/outlined/16',
  teammates: 'users-01/outlined/20',
  teammatesFilled: 'users-01/filled/20',
  teammatesFilledSmall: 'users-01/filled/16',
  teammatesSmall: 'users-01/outlined/16',
  template: 'user-edit/filled/20',
  templateSmall: 'user-edit/filled/16',
  textExpandSmall: 'paragraph-spacing/outlined/16',
  thumbsdownSmall: 'thumbs-down/outlined/16',
  thumbsup: 'thumbs-up/outlined/20',
  thumbsupSmall: 'thumbs-up/outlined/16',
  ticketFilled: 'ticket-01/filled/16',
  ticketSmall: 'ticket-01/outlined/16',
  timeFilledSmall: 'clock/filled/16',
  timeSmall: 'clock/outlined/16',
  toggles: 'settings-03/outlined/20',
  togglesFilled: 'settings-03/filled/20',
  togglesFilledSmall: 'settings-03/filled/16',
  togglesSmall: 'settings-03/outlined/16',
  topicActivity: 'target-03/outlined/12',
  topicFilledSmall: 'target-03/filled/16',
  topicSmall: 'target-03/outlined/16',
  transcriptActivity: 'align-left/outlined/12',
  translationSmall: 'translate-01/outlined/16',
  trash: 'trash-03/outlined/20',
  trash01Small: 'trash-03/outlined/16',
  trashActivity: 'trash-03/outlined/12',
  trashFilled: 'trash-03/filled/20',
  trashFilledSmall: 'trash-03/filled/16',
  trashSmall: 'trash-03/outlined/16',
  twitterFilled: 'twitter-x/filled/20',
  twitterSmall: 'twitter-x/outlined/16',
  unarchiveActivityFilled: 'archive-off/filled/12',
  unassign: 'user-right-off/filled/20',
  unassignActivity: 'user-right-01/outlined/12',
  unassignActivityFilled: 'user-right-01/filled/12',
  unassignedFilled: 'user-right-01/filled/20',
  unassignedFilledSmall: 'user-right-01/filled/16',
  unassignedSmall: 'user-right-01/outlined/16',
  unlink: 'link-broken-03/outlined/20',
  unlinkSmall: 'link-broken-03/outlined/16',
  unlinkedConversationsActivity: 'link-broken-03/outlined/12',
  unlinkedConversationsFilled: 'link-broken-03/filled/20',
  unlinkedConversationsFilledSmall: 'link-broken-03/filled/16',
  unlinkedConversationsSmall: 'link-broken-03/outlined/16',
  unpinOutlineSmall: 'unpin/outlined/16',
  unsubscribeTiny: 'bell-off-01/outlined/12',
  untag: 'tag-04/filled/20',
  untagActivity: 'tag-04/outlined/12',
  untagActivityFilled: 'tag-04/filled/12',
  userCircle02Small: 'user-circle/outlined/16',
  variable: 'variable/outlined/20',
  variableSmall: 'variable/outlined/16',
  verifiedFilledSmall: 'check-verified-02/filled/16',
  video: 'video-recorder/outlined/20',
  videoSmall: 'video-recorder/outlined/16',
  visitorSourceUrl: 'visitor-source/outlined/20',
  visitorSourceUrlSmall: 'visitor-source/outlined/16',
  voicemailSmall: 'voicemail/filled/16',
  volumeAudioFilled: 'volume-max/filled/20',
  warningActivity: 'alert-triangle/filled/12',
  warningFilledSmall: 'alert-triangle/filled/16',
  warningFilledTiny: 'alert-triangle/filled/12',
  warningFilledTriangle: 'alert-triangle/filled/20',
  wfmFilledSmall: 'shift/filled/16',
  wfmSmall: 'shift/outlined/16',
  whatsappSmall: 'whatsapp/outlined/16',
  windowsClose: 'windows-close/outlined/20',
  windowsMaximize: 'windows-maximize/outlined/20',
  windowsMinimize: 'windows-minimize/outlined/20',
  windowsUnmaximize: 'windows-unmaximize/outlined/20',
  workspaceFilledSmall: 'workspace/filled/16',
  workspaceSmall: 'workspace/outlined/16',
  xNoActivity: 'x-circle/filled/12',
};
